import { darkTheme, lightTheme } from '@/styles/theme/theme';

// Categorical palette for allocation bars — cycles through 4 colors in this fixed order:
// --color-accent-500 (also used for the Hours card progress bar and the allocation timeline
// chart, so "allocation 1" reads as the same color everywhere), colorPrimary light, colorSuccess
// dark, colorWarning dark. Unlike a validated dataviz palette this is meant to repeat once a
// user has more allocations than colors.
export const CATEGORICAL_PALETTE = [
  'var(--color-accent-500)',
  lightTheme.token!.colorPrimary!,
  darkTheme.token!.colorSuccess!,
  darkTheme.token!.colorWarning!,
];

// Cap on distinct allocation bars per user before extras fold into a shared "Other" bucket —
// decoupled from the 4-color palette above, which cycles within this cap.
export const MAX_CATEGORICAL_SERIES = 8;

// Reserved status color for a bar past the 100% utilization threshold — never reused for a
// categorical series.
export const CRITICAL_COLOR = darkTheme.token!.colorError!;
